import script from "./featureTestBench.vue?vue&type=script&lang=js"
export * from "./featureTestBench.vue?vue&type=script&lang=js"

import "./featureTestBench.vue?vue&type=style&index=0&id=154845b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-154845b8"]])

export default __exports__